import React from "react";
import MissionCards from "../sections/MissionCards";
import { faBullseye } from "@fortawesome/free-solid-svg-icons";
import ValeurCards from "../sections/ValeurCards";

const Mission = ({ missions }) => {
    if (!missions || missions.length === 0) {
        return null;
    }

    return (
        <div className="wow fadeInUp w-full" data-wow-delay="0.1s">
            <ValeurCards data={missions} icon={faBullseye} color={'purple'} />
        </div>
    );
};

export default Mission;